package org.example.project.screens_cus_mobile

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import kotlinx.coroutines.launch
import org.example.project.dashboard.LocalScreenRefreshVersion
import org.example.project.enginekalender.EngineMonthCalendar
import org.example.project.enginekalender.kalenderBookingMarkerColorHex
import org.example.project.enginekalender.kalenderDayState
import org.example.project.enginekalender.kalenderTodayIsoDate
import org.example.project.enginekalender.loadKalenderBookings
import org.example.project.enginekalender.parseKalenderIsoDate
import org.example.project.enginepersonal.ZeitApi
import org.example.project.enginepersonal.ZeitMobileDayPopup
import org.example.project.enginepersonal.ZeitMonth
import org.example.project.enginepersonal.ZeitMobileDayInfo
import org.example.project.enginepersonal.ZeitMobileMonthSummary
import org.example.project.enginepersonal.ZeitprofilConfig
import org.example.project.enginepersonal.UrlaubsuebersichtDayPopup
import org.example.project.enginepersonal.defaultZeitprofil
import org.example.project.enginepersonal.zeitMobileDayInfo
import org.example.project.enginepersonal.zeitMobileProfileHourRange
import org.example.project.enginepersonal.zeitMobileMonthLabel
import org.example.project.enginepersonal.zeitMobileMonthSummary
import org.example.project.manager.NodeScope
import org.example.project.screens_cus.Abwesenheitsbedarf
import org.example.project.screens_cus.UrlaubsApi
import org.example.project.screens_cus.ZeitkontoJournalEintrag
import org.example.project.service.LoginService
import org.example.project.service.ZustandManager
import org.example.project.settings.LumaticaButton
import org.example.project.settings.LumaticaButtonVariant
import org.example.project.settings.UISettings
import org.example.project.utils.All
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.value
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.Input
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import org.w3c.dom.events.Event
import org.w3c.dom.events.MouseEvent
import kotlin.js.Date
import kotlinx.browser.window
internal object MitarbeiterZeitkontoMobileStyles : StyleSheet() {
    val page by style {
        width(100.percent)
        property("max-width", "none")
        height(100.percent)
        property("margin", "0")
        padding(16.px)
        boxSizing("border-box")
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(14.px)
        overflowY("auto")
    }

    val header by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(12.px)
        paddingBottom(8.px)
    }

    val title by style {
        margin(0.px)
        color(Color.white)
        fontSize(22.px)
        fontWeight("700")
        textAlign("center")
    }

    val calendarCenter by style {
        width(100.percent)
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        alignItems(AlignItems.Stretch)
        gap(14.px)
        minHeight(0.px)
        overflowX("auto")
    }

    val calendarActionLayout by style {
        minHeight(0.px)
        display(DisplayStyle.Grid)
        gap(12.px)
        alignItems(AlignItems.Start)
        media(mediaMaxWidth(820.px)) {
            self style {
                gap(8.px)
                minWidth(620.px)
            }
        }
        media(mediaMaxWidth(560.px)) {
            self style {
                minWidth(560.px)
            }
        }
    }

    val compactCalendarPane by style {
        minWidth(0.px)
        minHeight(0.px)
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
    }

    val calendarSplitDivider by style {
        alignSelf(AlignSelf.Stretch)
        width(8.px)
        minHeight(260.px)
        borderRadius(99.px)
        backgroundColor(rgba(255, 255, 255, 0.08))
        cursor("col-resize")
        self + ":hover" style {
            backgroundColor(rgba(255, 255, 255, 0.18))
        }
        media(mediaMaxWidth(820.px)) {
            self style {
                width(6.px)
                minHeight(240.px)
            }
        }
    }

    val sideActionPane by style {
        minWidth(0.px)
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(10.px)
    }

    val sideToolbar by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.SpaceBetween)
        gap(10.px)
        minWidth(0.px)
        padding(2.px, 0.px)
    }

    val sideToolbarTitle by style {
        minWidth(0.px)
        color(Color.white)
        fontSize(15.px)
        fontWeight("900")
        property("word-break", "break-word")
    }

    val sideModeSwitch by style {
        flexShrink(0)
        display(DisplayStyle.Flex)
        gap(6.px)
    }

    val weekStrip by style {
        display(DisplayStyle.Grid)
        property("grid-template-columns", "repeat(7, minmax(44px, 1fr))")
        gap(6.px)
        minWidth(0.px)
    }

    val weekDayButton by style {
        position(Position.Relative)
        minWidth(0.px)
        height(58.px)
        padding(6.px)
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.Center)
        gap(2.px)
        color(Color.white)
        backgroundColor(rgba(255, 255, 255, 0.055))
        border(1.px, LineStyle.Solid, rgba(255, 255, 255, 0.12))
        borderRadius(8.px)
        boxSizing("border-box")
        cursor("pointer")
    }

    val weekDayButtonActive by style {
        property("box-shadow", "inset 0 0 0 2px #ff2f46")
    }

    val weekDayName by style {
        color(rgba(255, 255, 255, 0.58))
        fontSize(10.px)
        fontWeight("900")
    }

    val weekDayNumber by style {
        color(Color.white)
        fontSize(16.px)
        fontWeight("900")
        lineHeight("1")
    }

    val weekDayCount by style {
        position(Position.Absolute)
        top(4.px)
        right(4.px)
        minWidth(16.px)
        height(16.px)
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.Center)
        color(Color.white)
        backgroundColor(rgba(255, 47, 70, 0.82))
        borderRadius(99.px)
        fontSize(10.px)
        fontWeight("900")
    }

    val daySchedule by style {
        width(100.percent)
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(0.px)
        border(1.px, LineStyle.Solid, rgba(255, 255, 255, 0.12))
        borderRadius(8.px)
        overflow("hidden")
        backgroundColor(rgba(255, 255, 255, 0.04))
    }

    val listStack by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(10.px)
    }

    val statusTabs by style {
        display(DisplayStyle.Grid)
        property("grid-template-columns", "repeat(3, minmax(0, 1fr))")
        gap(8.px)
        width(100.percent)
        media(mediaMaxWidth(520.px)) {
            self style {
                property("grid-template-columns", "1fr")
            }
        }
    }

    val requestSection by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(10.px)
        padding(10.px)
        border(1.px, LineStyle.Solid, rgba(255, 255, 255, 0.12))
        borderRadius(8.px)
        backgroundColor(rgba(255, 255, 255, 0.035))
        boxSizing("border-box")
    }

    val requestSectionHeader by style {
        display(DisplayStyle.Flex)
        justifyContent(JustifyContent.SpaceBetween)
        alignItems(AlignItems.Center)
        gap(10.px)
        color(Color.white)
        fontSize(13.px)
        fontWeight("900")
        property("word-break", "break-word")
    }

    val listCard by style {
        padding(12.px)
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(8.px)
        color(Color.white)
        backgroundColor(rgba(255, 255, 255, 0.055))
        border(1.px, LineStyle.Solid, rgba(255, 255, 255, 0.12))
        borderRadius(8.px)
        boxSizing("border-box")
    }

    val cardTopRow by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.SpaceBetween)
        gap(10.px)
    }

    val cardTitle by style {
        minWidth(0.px)
        color(Color.white)
        fontSize(15.px)
        fontWeight("900")
        property("word-break", "break-word")
    }

    val statusPill by style {
        flexShrink(0)
        padding(5.px, 8.px)
        color(Color.white)
        backgroundColor(rgba(255, 47, 70, 0.22))
        border(1.px, LineStyle.Solid, rgba(255, 47, 70, 0.42))
        borderRadius(6.px)
        fontSize(11.px)
        fontWeight("900")
    }

    val cardMeta by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(4.px)
        color(rgba(255, 255, 255, 0.68))
        fontSize(12.px)
        fontWeight("700")
    }

    val dayScheduleHeader by style {
        display(DisplayStyle.Flex)
        justifyContent(JustifyContent.SpaceBetween)
        alignItems(AlignItems.Center)
        padding(10.px, 12.px)
        color(Color.white)
        backgroundColor(rgba(255, 255, 255, 0.07))
        fontSize(13.px)
        fontWeight("900")
    }

    val hourRow by style {
        display(DisplayStyle.Grid)
        property("grid-template-columns", "52px minmax(0, 1fr)")
        minHeight(48.px)
        property("border-top", "1px solid rgba(255,255,255,0.08)")
    }

    val normalHourRow by style {}

    val reservedHourRow by style {
        backgroundColor(rgba(37, 99, 235, 0.10))
    }

    val hourLabel by style {
        padding(10.px, 8.px)
        color(rgba(255, 255, 255, 0.54))
        fontSize(12.px)
        fontWeight("800")
        property("border-right", "1px solid rgba(255,255,255,0.08)")
    }

    val hourContent by style {
        minWidth(0.px)
        padding(6.px)
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(6.px)
    }

    val dayLabels by style {
        display(DisplayStyle.Flex)
        flexWrap(FlexWrap.Wrap)
        gap(8.px)
        padding(10.px, 12.px)
        property("border-top", "1px solid rgba(255,255,255,0.08)")
        backgroundColor(rgba(255, 255, 255, 0.03))
    }

    val dayLabel by style {
        padding(6.px, 10.px)
        color(Color.white)
        backgroundColor(rgba(37, 99, 235, 0.24))
        border(1.px, LineStyle.Solid, rgba(59, 130, 246, 0.48))
        borderRadius(6.px)
        fontSize(12.px)
        fontWeight("900")
    }

    val emptyHour by style {
        color(rgba(255, 255, 255, 0.26))
        fontSize(12.px)
    }

    val slot by style {
        padding(8.px, 10.px)
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(3.px)
        color(Color.white)
        backgroundColor(rgba(37, 99, 235, 0.20))
        border(1.px, LineStyle.Solid, rgba(59, 130, 246, 0.42))
        borderRadius(6.px)
        boxSizing("border-box")
    }

    val slotTitle by style {
        minWidth(0.px)
        color(Color.white)
        fontSize(13.px)
        fontWeight("900")
        property("word-break", "break-word")
    }

    val slotTime by style {
        color(UISettings.ACCENT)
        fontSize(11.px)
        fontWeight("800")
        whiteSpace("nowrap")
    }

    val slotDetail by style {
        color(rgba(255, 255, 255, 0.70))
        fontSize(11.px)
        fontWeight("700")
        property("word-break", "break-word")
    }

    val infoRow by style {
        display(DisplayStyle.Grid)
        property("grid-template-columns", "54px minmax(0, 1fr)")
        gap(8.px)
    }

    val infoLabel by style {
        color(rgba(255, 255, 255, 0.48))
        fontSize(11.px)
        fontWeight("700")
    }

    val infoValue by style {
        minWidth(0.px)
        color(rgba(255, 255, 255, 0.82))
        fontSize(13.px)
        property("word-break", "break-word")
    }

    val notice by style {
        padding(16.px)
        color(Color.white)
        backgroundColor(rgba(255, 255, 255, 0.06))
        border(1.px, LineStyle.Solid, rgba(255, 255, 255, 0.12))
        borderRadius(8.px)
    }

    val overlay by style {
        position(Position.Fixed)
        top(0.px)
        left(0.px)
        right(0.px)
        bottom(0.px)
        property("z-index", "100")
        backgroundColor(rgba(0, 0, 0, 0.58))
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.Center)
        padding(16.px)
        boxSizing("border-box")
    }

    val formPanel by style {
        width(100.percent)
        maxWidth(620.px)
        alignSelf(AlignSelf.Center)
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
    }

    val embeddedForm by style {
        width(100.percent)
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(14.px)
        color(Color.white)
        boxSizing("border-box")
    }

    val dialog by style {
        width(100.percent)
        maxWidth(420.px)
        padding(18.px)
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(14.px)
        color(Color.white)
        backgroundColor(Color("#15181d"))
        border(1.px, LineStyle.Solid, rgba(255, 255, 255, 0.16))
        borderRadius(8.px)
        boxSizing("border-box")
    }

    val dialogTitle by style {
        margin(0.px)
        fontSize(18.px)
        fontWeight("900")
        textAlign("center")
    }

    val metricsPanel by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(8.px)
    }

    val metricGroup by style {
        padding(10.px)
        border(1.px, LineStyle.Solid, rgba(255, 255, 255, 0.12))
        borderRadius(8.px)
        backgroundColor(rgba(255, 255, 255, 0.045))
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(8.px)
        boxSizing("border-box")
    }

    val metricGroupTitle by style {
        color(rgba(255, 255, 255, 0.62))
        fontSize(11.px)
        fontWeight("900")
        property("text-transform", "uppercase")
    }

    val metricGrid by style {
        display(DisplayStyle.Grid)
        property("grid-template-columns", "repeat(3, minmax(0, 1fr))")
        gap(8.px)
    }

    val summaryGrid by style {
        padding(10.px)
        property("border-top", "1px solid rgba(255,255,255,0.08)")
    }

    val metricItem by style {
        minWidth(0.px)
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        alignItems(AlignItems.Center)
        gap(3.px)
        textAlign("center")
    }

    val metricLabel by style {
        color(rgba(255, 255, 255, 0.44))
        fontSize(10.px)
        fontWeight("800")
        textAlign("center")
    }

    val metricValue by style {
        color(Color.white)
        fontSize(15.px)
        fontWeight("900")
        property("white-space", "nowrap")
        textAlign("center")
    }

    val metricValueLarge by style {
        color(Color.white)
        fontSize(17.px)
        fontWeight("900")
        property("white-space", "nowrap")
    }

    val sectionLabel by style {
        color(rgba(255, 255, 255, 0.62))
        fontSize(11.px)
        fontWeight("900")
        property("text-transform", "uppercase")
    }

    val dateField by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(6.px)
    }

    val typeSelector by style {
        display(DisplayStyle.Flex)
        flexWrap(FlexWrap.Wrap)
        gap(8.px)
    }

    val rangeSummary by style {
        minHeight(38.px)
        padding(8.px, 10.px)
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.SpaceBetween)
        gap(10.px)
        color(Color.white)
        backgroundColor(rgba(255, 255, 255, 0.06))
        border(1.px, LineStyle.Solid, rgba(255, 255, 255, 0.12))
        borderRadius(8.px)
        fontSize(13.px)
        fontWeight("800")
        boxSizing("border-box")
    }

    val rangeHeader by style {
        display(DisplayStyle.Grid)
        property("grid-template-columns", "42px minmax(0, 1fr) 42px")
        alignItems(AlignItems.Center)
        gap(8.px)
    }

    val rangeMonthLabel by style {
        color(Color.white)
        textAlign("center")
        fontSize(15.px)
        fontWeight("900")
    }

    val rangeGrid by style {
        display(DisplayStyle.Grid)
        property("grid-template-columns", "repeat(7, minmax(0, 1fr))")
        gap(4.px)
    }

    val mobileTimeLayout by style {
        display(DisplayStyle.Grid)
        property("grid-template-columns", "minmax(128px, 0.42fr) minmax(0, 1fr)")
        gap(10.px)
        alignItems(AlignItems.Start)
        media(mediaMaxWidth(560.px)) {
            self style {
                display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Column)
            }
        }
    }

    val mobileTimeMetrics by style {
        display(DisplayStyle.Grid)
        property("grid-template-columns", "repeat(2, minmax(0, 1fr))")
        gap(8.px)
        padding(10.px)
        border(1.px, LineStyle.Solid, rgba(255, 255, 255, 0.12))
        borderRadius(8.px)
        backgroundColor(rgba(255, 255, 255, 0.045))
        boxSizing("border-box")
    }

    val mobileTimeCalendar by style {
        display(DisplayStyle.Grid)
        property("grid-template-columns", "repeat(7, minmax(0, 1fr))")
        gap(5.px)
        minWidth(0.px)
    }

    val mobileMonthStack by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(12.px)
        minWidth(0.px)
    }

    val mobileDayFullscreen by style {
        position(Position.Fixed)
        top(0.px)
        left(0.px)
        right(0.px)
        bottom(0.px)
        property("z-index", "100")
        padding(16.px)
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.Center)
        backgroundColor(rgba(0, 0, 0, 0.36))
        boxSizing("border-box")
    }

    val mobileDayCard by style {
        width(100.percent)
        maxWidth(520.px)
        maxHeight(88.vh)
        overflow("auto")
        padding(14.px)
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(12.px)
        color(Color.white)
        backgroundColor(Color("#15181d"))
        border(1.px, LineStyle.Solid, rgba(255, 255, 255, 0.16))
        borderRadius(8.px)
        boxSizing("border-box")
        property("box-shadow", "0 18px 54px rgba(0,0,0,0.36)")
    }

    val timeInlineCard by style {
        marginTop(12.px)
        padding(12.px)
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(10.px)
        color(Color.white)
        border(1.px, LineStyle.Solid, rgba(255, 255, 255, 0.12))
        borderRadius(8.px)
        backgroundColor(rgba(255, 255, 255, 0.045))
        boxSizing("border-box")
    }

    val timeMonthGrid by style {
        display(DisplayStyle.Grid)
        property("grid-template-columns", "repeat(7, minmax(0, 1fr))")
        gap(5.px)
    }

    val rangeWeekday by style {
        height(24.px)
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.Center)
        color(rgba(255, 255, 255, 0.48))
        fontSize(11.px)
        fontWeight("900")
    }

    val rangeEmptyDay by style {
        height(36.px)
    }

    val rangeDay by style {
        height(36.px)
        padding(0.px)
        border(1.px, LineStyle.Solid, rgba(255, 255, 255, 0.10))
        borderRadius(6.px)
        backgroundColor(rgba(255, 255, 255, 0.04))
        color(Color.white)
        fontSize(13.px)
        fontWeight("900")
        cursor("pointer")
        boxSizing("border-box")
    }

    val timeDay by style {
        minHeight(54.px)
        padding(6.px, 4.px)
        position(Position.Relative)
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.Center)
        gap(3.px)
        border(1.px, LineStyle.Solid, rgba(255, 255, 255, 0.10))
        borderRadius(6.px)
        backgroundColor(rgba(255, 255, 255, 0.04))
        color(Color.white)
        cursor("pointer")
        boxSizing("border-box")
    }

    val timeDayWarning by style {
        position(Position.Absolute)
        right(5.px)
        top(5.px)
        width(15.px)
        height(15.px)
        borderRadius(50.percent)
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.Center)
        color(Color.white)
        backgroundColor(rgba(0, 0, 0, 0.34))
        fontSize(10.px)
        fontWeight("900")
        lineHeight("1")
    }

    val timeDaySelected by style {
        backgroundColor(rgba(255, 47, 70, 0.20))
        property("border-color", "rgba(255,47,70,0.56)")
    }

    val timeDayNumber by style {
        fontSize(13.px)
        fontWeight("900")
    }

    val timeDayHours by style {
        color(UISettings.ACCENT)
        fontSize(10.px)
        fontWeight("900")
        property("white-space", "nowrap")
    }

    val rangeDayMuted by style {
        color(rgba(255, 255, 255, 0.38))
        backgroundColor(rgba(255, 255, 255, 0.025))
    }

    val rangeDayBooked by style {
        color(rgba(255, 255, 255, 0.28))
        backgroundColor(rgba(255, 255, 255, 0.08))
        property("border-color", "rgba(255,255,255,0.12)")
        property("text-decoration", "line-through")
        cursor("not-allowed")
    }

    val rangeDayInRange by style {
        backgroundColor(rgba(255, 47, 70, 0.18))
        property("border-color", "rgba(255,47,70,0.38)")
    }

    val rangeDayEdge by style {
        backgroundColor(Color("#ff2f46"))
        property("border-color", "#ff2f46")
        color(Color.white)
    }

    val dateInput by style {
        width(100.percent)
        height(42.px)
        padding(0.px, 10.px)
        boxSizing("border-box")
        color(Color.white)
        backgroundColor(rgba(255, 255, 255, 0.08))
        border(1.px, LineStyle.Solid, rgba(255, 255, 255, 0.18))
        borderRadius(8.px)
        fontSize(15.px)
    }

    val dialogInfo by style {
        color(UISettings.ACCENT)
        fontSize(13.px)
        fontWeight("800")
    }

    val dialogMessage by style {
        color(Color("#ff8a8a"))
        fontSize(13.px)
        fontWeight("700")
    }

    val dialogActions by style {
        display(DisplayStyle.Flex)
        justifyContent(JustifyContent.FlexEnd)
        gap(10.px)
        flexWrap(FlexWrap.Wrap)
    }

    val timePopup by style {
        width(100.percent)
        maxWidth(440.px)
        maxHeight(88.vh)
        overflow("auto")
        padding(16.px)
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(12.px)
        color(Color.white)
        backgroundColor(Color("#15181d"))
        border(1.px, LineStyle.Solid, rgba(255, 255, 255, 0.16))
        borderRadius(8.px)
        boxSizing("border-box")
    }

    val timePopupTop by style {
        display(DisplayStyle.Grid)
        property("grid-template-columns", "42px minmax(0, 1fr) 42px")
        alignItems(AlignItems.Center)
        gap(8.px)
    }

    val timePopupRows by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(8.px)
        padding(10.px)
        border(1.px, LineStyle.Solid, rgba(255, 255, 255, 0.12))
        borderRadius(6.px)
        backgroundColor(rgba(255, 255, 255, 0.035))
    }

    val infoGrid by style {
        display(DisplayStyle.Grid)
        property("grid-template-columns", "1fr 1fr")
        gap(8.px)
    }

    val popupTable by style {
        width(100.percent)
        display(DisplayStyle.Grid)
        property("grid-template-columns", "1fr 1fr")
        property("grid-auto-rows", "minmax(38px, max-content)")
        alignContent(AlignContent.Start)
        gap(0.px)
        border(1.px, LineStyle.Solid, rgba(255, 255, 255, 0.12))
        borderRadius(5.px)
        overflow("hidden")
    }

    val popupTableRow by style {
        display(DisplayStyle.Contents)
    }

    val popupTableCell by style {
        padding(9.px, 12.px)
        color(rgba(255, 255, 255, 0.62))
        fontSize(14.px)
        fontWeight("800")
        property("border-bottom", "1px solid rgba(255,255,255,0.08)")
        property("border-right", "1px solid rgba(255,255,255,0.08)")
        backgroundColor(rgba(255, 255, 255, 0.03))
        property("white-space", "nowrap")
    }

    val popupTableValue by style {
        padding(9.px, 12.px)
        color(Color.white)
        fontSize(14.px)
        fontWeight("900")
        textAlign("right")
        property("border-bottom", "1px solid rgba(255,255,255,0.08)")
        backgroundColor(rgba(255, 255, 255, 0.02))
        property("white-space", "nowrap")
    }

    val emptyDetail by style {
        padding(14.px)
        color(rgba(255, 255, 255, 0.58))
        fontSize(13.px)
        fontWeight("700")
    }

    val error by style {
        padding(16.px)
        color(Color.white)
        backgroundColor(rgba(140, 26, 26, 0.48))
        border(1.px, LineStyle.Solid, rgba(255, 116, 116, 0.42))
        borderRadius(8.px)
    }
}

